<template>
    <div>
        <a :id="heading1.Anchor"></a>
        <h1 class="mt-10 font-semibold text-5xl text-gray-800">{{ heading1.Text }}</h1>

        <a :id="heading2.Anchor"></a>
        <h2 class="mt-8 font-semibold text-4xl text-gray-800">{{ heading2.Text }}</h2>

        <a :id="heading3.Anchor"></a>
        <h3 class="mt-6 font-semibold text-3xl text-gray-800">{{ heading3.Text }}</h3>

        <a :id="heading4.Anchor"></a>
        <h4 class="mt-5 font-semibold text-2xl text-gray-800">{{ heading4.Text }}</h4>

        <a :id="heading5.Anchor"></a>
        <h5 class="mt-4 font-semibold text-xl text-gray-800">{{ heading5.Text }}</h5>

        <a :id="heading6.Anchor"></a>
        <h6 class="mt-4 font-semibold text-lg text-gray-800">{{ heading6.Text }}</h6>
    </div>
</template>

<script>
    export default {
        name: "Headings",
        data() {
            return {
                heading1: {
                    Anchor: 'heading1',
                    Text: 'Heading 1'
                },
                heading2: {
                    Anchor: 'heading2',
                    Text: 'Heading 2'
                },
                heading3: {
                    Anchor: 'heading3',
                    Text: 'Heading 3'
                },
                heading4: {
                    Anchor: 'heading4',
                    Text: 'Heading 4'
                },
                heading5: {
                    Anchor: 'heading5',
                    Text: 'Heading 5'
                },
                heading6: {
                    Anchor: 'heading6',
                    Text: 'Heading 6'
                }
            }
        }
    };
</script>